import React from 'react';

export default function LiveIvrConfirmation({
  liveIvr,
  admin,
  confirmed,
  setConfirmed,
  disabled,
  t,
}) {
  return (
    <>
      {liveIvr.required && (
        <section
          className="mb-4 rounded-lg border border-amber-300 bg-amber-50 p-3 text-[12px] text-slate-800"
          aria-label={t('Live insurance verification')}
        >
          {admin && (
            <p className="mb-2">
              {t('Live checks are stored privately without a demo clinic assignment.')}
            </p>
          )}
          {!liveIvr.ready ? (
            <p role={liveIvr.status === 'unavailable' ? 'alert' : 'status'}>
              {t(
                liveIvr.status === 'unavailable'
                  ? 'Live insurance verification is unavailable. Close this form and try again.'
                  : 'Checking private live IVR access...'
              )}
            </p>
          ) : !admin ? (
            <p role="alert">{t('Only an administrator can submit live insurance verification.')}</p>
          ) : (
            <label className="flex items-start gap-2">
              <input
                type="checkbox"
                checked={confirmed}
                disabled={disabled}
                className="mt-0.5 h-4 w-4 shrink-0"
                onChange={(event) => setConfirmed(event.target.checked)}
              />
              <span>
                {t(
                  'I confirm this submission uses real patient information and will send an insurance verification request to pVerify. I am authorized to submit it.'
                )}
              </span>
            </label>
          )}
        </section>
      )}
    </>
  );
}
